import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `movimientoVerraco/editMovimientoVerraco`, method: 'POST', body: values, token: token})
}